export default __webpack_public_path__ + "static/media/mic.4442790f.svg";